<template lang="pug">
#modal-ambiente(style='z-index: 4000')
    el-dialog(
        width='500px',
        top='5vh',
        :visible='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        @close='$emit("close")'
    )
        span(slot='title').modal-linguagem-header
            h1 {{ $t('mensagens.comuns.selecioneEmpresaDesejada') }}
        .modal-linguagem-content
            p {{ $t('mensagens.menuSuperior.selecaoEmpresa') }}
            el-radio-group(v-model='empresaSelecionada')
                    el-radio.select-pais(
                            v-for='empresa in empresas'
                            :key='empresa.id'
                            :label='empresa.nome'
                            border
                        )
                        .sl-flag.flag-pt-BR(v-if='empresa.siglaPais === ambientes.BRASIL')
                        .sl-flag.flag-paraguai(v-else-if='empresa.siglaPais === ambientes.PARAGUAY')
                        .sl-flag.flag-argentina(v-else-if='empresa.siglaPais === ambientes.ARGENTINA')
                        | {{ empresa.nome }}

        div(slot='footer')
            .buttons
                el-button(size='mini', @click='$emit("close")')
                    | {{ $t('mensagens.comuns.cancelar') }}
                el-button(
                    type='primary',
                    size='mini',
                    @click='confirmarEscolhas'
                )
                    | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'ModalAmbiente',
    props: {
        show: {
            type: Boolean
        },
        empresas: {
            type: Array
        }
    },
    data() {
        return {
            ambientes: AmbientesEmpresas,
            empresaAnterior: null,
            empresaSelecionada: null,
            linguagem: null
        };
    },
    methods: {
        alterarAmbiente(novoAmbiente) {
            this.$emit('alterarAmbiente', novoAmbiente);
        },

        confirmarEscolhas() {
            if (this.empresaSelecionada && this.empresaSelecionada !== this.empresaAnterior) {
                this.empresaAnterior = this.empresaSelecionada;
                this.alterarAmbiente(this.empresaSelecionada);
            }
            this.$emit('close');
        }
    }
};
</script>
<style lang="scss">
#modal-ambiente {
    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px !important;

        h1 {
            margin: 0;
            font-size: 18px;
            font-weight: 500;
            color: var(--primary) !important;
        }
    }

    .modal-linguagem-header {
        display: flex;
        justify-content: flex-start;
        align-items:flex-start
    }
    
    .modal-linguagem-content {
        padding: 9px;
        display: flex;
        flex-direction: column;
        margin-left: -8px;

        h1 {
            font-size: 18px;
            color: var(--primary-font-color);
        }

        p {
            font-size: 14px;
            color: var(--primary-font-color);
        }
    }
    .select-pais {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        padding-bottom: 12px;
        font-size: 16px;
        font-weight: 400;
        color: var(--primary-font-color);
        cursor: pointer;
        .el__radio {
            height: 50px !important;
        }
        .sl-flag {
            height: 10px;
            width: 15px;
            margin-right: 20px;
        }
    }
    .linguagem {
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        gap: 10px;
        padding-bottom: 12px;
        font-size: 16px;
        color: var(--primary-font-color);
        font-weight: 400;
        cursor: pointer;
    }
    .linguagem:hover {
        background: #f5f5f5;
    }
    .language-code {
        margin-left: 20px;
        color: var(--secondary-font-color);
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>
